import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { sectionLc } from '../../../actions/section';
import LcChoose from './LcChoose';
import LcWatch from './LcWatch';
import LcTrack from './LcTrack';
import LcPic from './LcPic';
import { shadowSize } from '../../../utils/utils';

export class Lc extends React.Component {
	componentDidMount() {
		this.props.sectionLc();
		shadowSize();
	}
	render() {
        return (
			<div id="lc" className="char section">
			    <LcChoose />
			    <LcWatch />
			    <LcTrack />
			    <LcPic />
			</div>
		);
    }
};

const mapDispatchToProps = (dispatch) => ({
	sectionLc: () => dispatch(sectionLc())
});

export default connect(undefined, mapDispatchToProps)(Lc);



// WEBPACK FOOTER //
// ./src/components/sections/lc/Lc.js